import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {InstructorProgramCourseSelection} from "../Providers/InstructorProgramsProvider";
import {FilterByActiveOrCanceled} from "../../pages/instructor/ActivityDetailView";
import moment from "moment";

type Props = {
    courseSection : InstructorProgramCourseSelection;
    showActiveOrCanceled: FilterByActiveOrCanceled;
};

const generateColums = (courseSection : InstructorProgramCourseSelection) => {
    return [
        {
            dataField: 'studentId',
            text: courseSection.allowCommunity ? 'Student / Community Member ID' : 'Student ID',
            sort: true,
        },
        {
            dataField: 'studentName',
            text: 'Student Name',
            sort: true,
            formatter: (cell: string, row: DisplayCourse) => {
                return `${row.nameFirst} ${row.nameLast}`
            },
        },
        {
            dataField: 'grade',
            text: 'Grade',
            sort: true,
            classes: 'd-none d-lg-table-cell',
            headerClasses: 'd-none d-lg-table-cell',
        },
        {
            dataField: 'gender',
            text: 'Gender',
            sort: true,
            classes: 'd-none d-lg-table-cell',
            headerClasses: 'd-none d-lg-table-cell',
        },
        {
            dataField: 'timestamp',
            text: 'Date Registered',
            formatter: (cell: string) => {
                return moment(cell).format('MM/DD/YYYY h:mm a');
            },
            sort: true,
            classes: 'd-none d-lg-table-cell',
            headerClasses: 'd-none d-lg-table-cell',
        },
    ];
};

type DisplayCourse = {
    studentId : string;
    studentName : string;
    nameFirst : string;
    nameLast : string;
    grade ?: number;
    gender : string;
    timestamp : string;
};

const ActivityRegistrationTable = ({
    courseSection,
    showActiveOrCanceled,
} : Props) => {
    const columns = generateColums(courseSection);
    const roster : (DisplayCourse | null)[] = courseSection.registrations.map(registration => {

        if (showActiveOrCanceled === 'active' && registration.status !== null) {
            return null;
        }

        if (showActiveOrCanceled === 'canceled' && registration.status === null) {
            return null;
        }

        if (registration.student) {
            return {
                studentId: registration.student.id.toString(),
                studentName: `${registration.student.nameLast}, ${registration.student.nameFirst}`,
                nameFirst: registration.student.nameFirst,
                nameLast: registration.student.nameLast,
                grade: registration.student.grade,
                gender: registration.student.gender,
                timestamp: registration.createdAt,
            } as DisplayCourse
        }
        if (registration.communityMember) {
            return {
                studentId: registration.communityMember.id,
                studentName: `${registration.communityMember.nameLast}, ${registration.communityMember.nameFirst}`,
                nameFirst: registration.communityMember.nameFirst,
                nameLast: registration.communityMember.nameLast,
                grade: registration.communityMember.grade,
                gender: registration.communityMember.gender,
                timestamp: registration.createdAt,
            } as DisplayCourse
        }
        return null;

    }).filter(studentOrCommunityMember => studentOrCommunityMember !== null);

    return (
        <BootstrapTable
            bootstrap4
            keyField='studentId'
            data={roster}
            columns={columns}
            pagination={paginationFactory({sizePerPage: 40}) }
            striped
            defaultSorted={[{dataField: 'studentName', order: 'asc'}]}
        />
    );
};

export default ActivityRegistrationTable;
